import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsContent from '../Wrapper.vue';
import LeadScoringSettings from './LeadScoringSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lead-scoring'),
      component: SettingsContent,
      props: () => ({
        // Um titulo so, em portugues e com a palavra do cliente: o cabecalho
        // dizia "Lead Scoring" e a pagina logo abaixo "Pontuacao de contatos".
        headerTitle: 'WORKSPACE_V2.SCORING.TITLE',
        icon: 'flash',
        showNewButton: false,
        showBackButton: false,
      }),
      children: [
        {
          path: '',
          name: 'lead_scoring_settings',
          component: LeadScoringSettings,
          // Mesmo portao do menu: modulo pago, sem a flag a tela nao abre.
          meta: {
            featureFlag: FEATURE_FLAGS.LEAD_SCORING,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
